import { coreGet } from "./api-client";
import type {
  CaseDetail,
  CaseSummary,
  ContactDetail,
  ContactSummary,
  CustomerDetail,
  CustomerSummary,
  OperationsContext,
  OverviewDashboard,
  OverviewPeriod,
  OperationsPage,
  OperationsSearchResult,
} from "../core-contracts/operations";

export function loadOperationsContext(signal?: AbortSignal) {
  return coreGet<OperationsContext>("/operations/context", signal);
}

export function loadOverview(period: OverviewPeriod, signal?: AbortSignal) {
  return coreGet<OverviewDashboard>(
    `/operations/overview?period=${encodeURIComponent(period)}`,
    signal,
  );
}

export function loadCustomers(query = "", signal?: AbortSignal) {
  return coreGet<OperationsPage<CustomerSummary>>(
    `/operations/customers?${query}`,
    signal,
  );
}

export function loadCustomer(id: string, signal?: AbortSignal) {
  return coreGet<CustomerDetail>(
    `/operations/customers/${encodeURIComponent(id)}`,
    signal,
  );
}

export function loadContacts(query = "", signal?: AbortSignal) {
  return coreGet<OperationsPage<ContactSummary>>(
    `/operations/contacts?${query}`,
    signal,
  );
}

export function loadContact(id: string, signal?: AbortSignal) {
  return coreGet<ContactDetail>(
    `/operations/contacts/${encodeURIComponent(id)}`,
    signal,
  );
}

export function loadCases(query = "", signal?: AbortSignal) {
  return coreGet<OperationsPage<CaseSummary>>(
    `/operations/cases?${query}`,
    signal,
  );
}

export function loadCase(id: string, signal?: AbortSignal) {
  return coreGet<CaseDetail>(
    `/operations/cases/${encodeURIComponent(id)}`,
    signal,
  );
}

export function searchOperations(query: string, signal?: AbortSignal) {
  return coreGet<OperationsSearchResult>(
    `/operations/search?q=${encodeURIComponent(query)}`,
    signal,
  );
}
